// src/components/SEO/index.js
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { fetchSeo } from "../../lib/seo";
import SeoHelmet from "../SeoHelmet";
import JsonLd from "../JsonLd";
import SeoDebug from "../SeoDebug";

const SEO = () => {
  const location = useLocation();
  const params = useParams();
  const [seo, setSeo] = useState(null);

  useEffect(() => {
    let isMounted = true;

    let path = location.pathname;
    const publicUrl = process.env.PUBLIC_URL || "";
    if (publicUrl && path.startsWith(publicUrl)) {
      path = path.slice(publicUrl.length);
    }
    if (!path.startsWith("/")) {
      path = `/${path}`;
    }

    const slug = params.slug || params.blogID || params.packageName || params.blogUrl || path || "/";

    fetchSeo(slug)
      .then((data) => {
        if (isMounted) {
          setSeo(data);
        }
      })
      .catch((err) => {
        console.error("[SEO] Fetch error in component:", err);
        if (isMounted) {
          setSeo(null);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [location.pathname, params]);

  return (
    <>
      <SeoHelmet seo={seo} />
      <JsonLd data={seo?.jsonLd} />
      <SeoDebug seo={seo} />
    </>
  );
};

export default SEO;
